import { useEffect } from "react"

const RED_HAT_TEXT_FONT_URL =
  "https://fonts.googleapis.com/css2?family=Red+Hat+Text:wght@400;500;600;700&display=swap"

export function loadRedHatTextFont() {
  if (document.querySelector("link[data-red-hat-text]")) return
  const link = document.createElement("link")
  link.rel = "stylesheet"
  link.dataset.redHatText = "true"
  link.href = RED_HAT_TEXT_FONT_URL
  document.head.appendChild(link)
}

export function useRedHatTextFont() {
  useEffect(() => {
    loadRedHatTextFont()
  }, [])
}
